import { Link } from 'react-router-dom';  

function TopNavigationMenu ()
{

return (
    <div>

<p style={{ textAlign: "center"  }}>
    ​<span style={{ color: "#000000" }}>Anlægspavillonen</span>
  </p>
  <p style={{ textAlign: "center" }}>
    <span style={{ color: "#000000" }}>Tværalle 5</span>
    <br />
  </p>
  <p style={{ textAlign: "center" }}>
    <span style={{ color: "#000000" }}>4100 Ringsted</span>
  </p >
    </div>
  );
}


export default TopNavigationMenu;